module.exports = __webpack_public_path__ + "img/example1.0a83c5b.png";